import { Aspect } from '@teambit/harmony';

export const EnvsAspect = Aspect.create({
  id: 'teambit.envs/envs',
});
